module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="intercomStubLoader js-intercom-loading-stub">\n    <div class="intercomStubLoader-close js-intercom-loading-stub-close">\n        <i class="intercomStubLoader-close__icon"></i>\n    </div>\n\n    <div class="intercomStubLoader-spinner">\n        <div class="intercomStubLoader-spinner__loader"></div>\n    </div>\n\n    <div class="intercomStubLoader__title">\n        Ожидайте, чат&nbsp;загружается\n    </div>\n</div>\n';
}
return __p;
};
